import { render, staticRenderFns } from "./ota-list.vue?vue&type=template&id=3e0105f7&"
import script from "./ota-list.vue?vue&type=script&lang=ts&"
export * from "./ota-list.vue?vue&type=script&lang=ts&"
import style0 from "./ota-list.vue?vue&type=style&index=0&id=3e0105f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports